import { render, staticRenderFns } from "./DepartmentBillingPlan.vue?vue&type=template&id=2431a716&scoped=true&"
import script from "./DepartmentBillingPlan.vue?vue&type=script&lang=js&"
export * from "./DepartmentBillingPlan.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentBillingPlan.vue?vue&type=style&index=0&id=2431a716&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2431a716",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAlert,VBtn,VCard,VCardText,VExpandTransition,VSwitch})
